"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConfirmAwaitingOutput = exports.failedResult = exports.executedResult = exports.abandonedResult = exports.TOOL_NOT_REGISTERED_RESULT = exports.PROPOSED_ARGS_INVALID_RESULT = exports.NOT_AUTHORIZED_RESULT = exports.EXECUTE_TIMEOUT_RESULT = exports.EXECUTE_THREW_RESULT = exports.CONFIRM_ONCE_PER_STEP_RESULT = exports.CONFIRM_ERROR = void 0;
const tool_catalogue_interface_1 = require("@llj/ai-service-interface/dist/entities/tool-catalogue.interface");
const result_1 = require("../../core/result");
const errors_1 = require("../../core/errors");
const CONFIRM_ERROR = {
    CONFIRM_ONCE_PER_STEP: 'CONFIRM_ONCE_PER_STEP',
    PROPOSED_ARGS_INVALID: 'PROPOSED_ARGS_INVALID',
};
exports.CONFIRM_ERROR = CONFIRM_ERROR;
const isConfirmAwaitingOutput = (value) => typeof value === 'object' && value !== null &&
    value.status === 'awaiting_confirmation';
exports.isConfirmAwaitingOutput = isConfirmAwaitingOutput;
const executedResult = (toolName, result) => ({ status: 'executed', message: (0, tool_catalogue_interface_1.confirmMessagesOf)(toolName).executed, result });
exports.executedResult = executedResult;
const failedResult = (error, message) => ({ status: 'failed', error, message });
exports.failedResult = failedResult;
const abandonedResult = (toolName, reason) => ({ status: reason, message: (0, tool_catalogue_interface_1.confirmMessagesOf)(toolName)[reason] });
exports.abandonedResult = abandonedResult;
const NOT_AUTHORIZED_RESULT = failedResult(errors_1.TOOL_ERROR.TOOL_NOT_AUTHORIZED, '使用者目前已沒有這項操作的權限（權限、模組或功能開關在出卡後有變動），沒有執行。');
exports.NOT_AUTHORIZED_RESULT = NOT_AUTHORIZED_RESULT;
const PROPOSED_ARGS_INVALID_RESULT = failedResult(CONFIRM_ERROR.PROPOSED_ARGS_INVALID, '確認卡上的參數格式不正確，沒有執行。請重新整理參數後再出一次確認卡。');
exports.PROPOSED_ARGS_INVALID_RESULT = PROPOSED_ARGS_INVALID_RESULT;
const TOOL_NOT_REGISTERED_RESULT = failedResult(errors_1.TOOL_ERROR.TOOL_NOT_REGISTERED, '這項操作目前無法執行（工具未註冊），沒有執行。');
exports.TOOL_NOT_REGISTERED_RESULT = TOOL_NOT_REGISTERED_RESULT;
const EXECUTE_TIMEOUT_RESULT = failedResult(errors_1.TOOL_ERROR.TOOL_TIMEOUT, '執行逾時，無法確認是否已完成。請使用者先到後台查看結果，不要直接重試。');
exports.EXECUTE_TIMEOUT_RESULT = EXECUTE_TIMEOUT_RESULT;
const EXECUTE_THREW_RESULT = failedResult(errors_1.TOOL_ERROR.TOOL_FAILED, '執行時發生錯誤，沒有完成。請告訴使用者稍後再試。');
exports.EXECUTE_THREW_RESULT = EXECUTE_THREW_RESULT;
const CONFIRM_ONCE_PER_STEP_RESULT = (0, result_1.toolFailure)(CONFIRM_ERROR.CONFIRM_ONCE_PER_STEP, '同一步只能送出一張確認卡，這一張沒有送給使用者；請等使用者處理完再呼叫。');
exports.CONFIRM_ONCE_PER_STEP_RESULT = CONFIRM_ONCE_PER_STEP_RESULT;
//# sourceMappingURL=result.js.map